import React, { createContext, useState } from "react"
import { useContext } from "react"
import { logoutUser, logoutCU } from "../services/auth.service"
import {toast} from "react-toastify"

const UserContext = createContext()

const UserProvider = ({ children }) => {
	const [user, setUser] = useState(null)

	const setUserToken = token => {
		localStorage.setItem("ssid", token)
	}

	const logout = async () => {
		const logApi = await logoutUser()
		if (logApi?.response === "success") {
			toast.info("Sesión finalizada")
			localStorage.removeItem("ssid")
		}
		setUser(null)
		// logoutCU()
	}


	const value = {
		user,
		setUser,
		setUserToken,
		logout
	}

	return <UserContext.Provider value={value}>{children}</UserContext.Provider>
}

const useUser = () => {
	const context = useContext(UserContext)
	if (!context) {
		throw new Error("UseUser debe star dentro del proveedor UserProvider")
	}
	return context
}

export { useUser, UserProvider }
